export default __webpack_public_path__ + "high_m0a94b5.png";